// =====================================================
// TYPES: SCHOOL
// Description: Types TypeScript pour les écoles
// =====================================================

export interface School {
  id: string;
  name: string; // Nom de l'école
  postal_code: string | null; // Code postal
  city: string | null; // Ville
  country: string; // Pays (code ISO)
  type: string | null; // Type d'école
  positioning: string | null; // Positionnement (Favorable, Neutre, etc.)
  address: string | null; // Adresse complète (texte libre)
  notes: string | null; // Notes
  // Personne à contacter
  contact_first_name: string | null; // Prénom du contact
  contact_last_name: string | null; // Nom du contact
  contact_email: string | null; // Email du contact
  contact_phone: string | null; // Téléphone du contact
  created_at: string;
  updated_at: string;

  // Comptage des contacts (quand inclus via aggregation)
  contacts?: { count: number }[];
}

export interface CreateSchoolDto {
  name: string;
  postal_code?: string | null;
  city?: string | null;
  country?: string;
  type?: string | null;
  positioning?: string | null;
  address?: string | null;
  notes?: string | null;
  // Personne à contacter
  contact_first_name?: string | null;
  contact_last_name?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
}

export interface UpdateSchoolDto {
  name?: string;
  postal_code?: string | null;
  city?: string | null;
  country?: string;
  type?: string | null;
  positioning?: string | null;
  address?: string | null;
  notes?: string | null;
  // Personne à contacter
  contact_first_name?: string | null;
  contact_last_name?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
}

// Types d'écoles disponibles
export const SCHOOL_TYPES = [
  'Université',
  "École d'ingénieur",
  'École de commerce',
  'BTS',
  'IUT',
  'Autre',
] as const;

export type SchoolType = (typeof SCHOOL_TYPES)[number];

// Positionnements disponibles
export const POSITIONINGS = [
  'Favorable',
  'Neutre',
  'Défavorable',
  'À contacter',
  'En attente',
] as const;

export type Positioning = (typeof POSITIONINGS)[number];

// Pays disponibles (synchronisé avec COUNTRY_CODES de phone-input.tsx)
export const COUNTRIES = [
  { code: 'FRA', label: 'France' },
  { code: 'BEL', label: 'Belgique' },
  { code: 'CHE', label: 'Suisse' },
  { code: 'LUX', label: 'Luxembourg' },
  { code: 'MCO', label: 'Monaco' },
  { code: 'ESP', label: 'Espagne' },
  { code: 'MAR', label: 'Maroc' },
  { code: 'PRT', label: 'Portugal' },
  { code: 'ITA', label: 'Italie' },
  { code: 'DEU', label: 'Allemagne' },
  { code: 'GBR', label: 'Royaume-Uni' },
  { code: 'NLD', label: 'Pays-Bas' },
  { code: 'HUN', label: 'Hongrie' },
  { code: 'AUT', label: 'Autriche' },
  { code: 'DZA', label: 'Algérie' },
  { code: 'CAN', label: 'Canada' },
  { code: 'USA', label: 'États-Unis' },
  { code: 'EGY', label: 'Égypte' },
  { code: 'TUN', label: 'Tunisie' },
  { code: 'SEN', label: 'Sénégal' },
  { code: 'CIV', label: "Côte d'Ivoire" },
  { code: 'MLI', label: 'Mali' },
  { code: 'NER', label: 'Niger' },
  { code: 'MRT', label: 'Mauritanie' },
  { code: 'SAU', label: 'Arabie saoudite' },
  { code: 'ARE', label: 'Émirats arabes unis' },
  { code: 'SRB', label: 'Serbie' },
] as const;
